import {Component, Input, OnChanges, ViewChild} from '@angular/core';
import {FileService} from '../../../../services/file.service';
import {LoadingService} from '../../../../services/loading.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {ToastMessagesService} from '../../../../services/toast-messages.service';
import {CommonService} from '../../../../services/common.service';

@Component({
  selector: 'app-sale-point-plirotis-second-step',
  templateUrl: './sale-point-plirotis-second-step.component.html'
})
export class SalePointPlirotisSecondStepComponent implements OnChanges {
  @Input() data: any[];
  @Input() file: any;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  public dataSource: MatTableDataSource<any>;
  public displayedColumns: string[];

  constructor(private fileService: FileService,
              private loadingService: LoadingService,
              private commonService: CommonService,
              private toastMessagesService: ToastMessagesService) {
    this.dataSource = new MatTableDataSource();
    this.displayedColumns = [
      'plirotis_code',
      'plirotis_name',
      'vat_number'
    ];
  }

  public ngOnChanges(): void {
    this.dataSource = new MatTableDataSource(this.data);
    this.paginator._intl.itemsPerPageLabel = 'Εγγραφές Ανά Σελίδα';
    this.paginator._intl.firstPageLabel = 'Πρώτη Σελίδα';
    this.paginator._intl.lastPageLabel = 'Τελευταία Σελίδα';
    this.paginator._intl.nextPageLabel = 'Επόμενη Σελίδα';
    this.paginator._intl.previousPageLabel = 'Προηγούμενη Σελίδα';

    this.paginator._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) {
        return `0 από ${length}`;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
      return `${startIndex + 1} - ${endIndex} από ${length}`;
    };
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  public async submitProcess(): Promise<any> {
    try {
      this.loadingService.show();
      const body = {
        data: this.data
      };
      await this.commonService.insertObject('sale_point_plirotis/xlsx', body);
      this.toastMessagesService.toastMessages(`Η μεταφόρτωση ολοκληρώθηκε με επιτυχία`);
    } catch (error) {
      this.toastMessagesService.toastErrorMessage(error.error.message);
    } finally {
      this.loadingService.hide();
    }
  }
}
